// Preventing above the fold images from lazily loading
document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('img');
    images.forEach(img => {
        if (img.getBoundingClientRect().top < window.innerHeight) {
            img.classList.remove('lazyautosizes', 'lazyloaded', 'ls-is-cached');
            img.removeAttribute('loading');
            img.removeAttribute('data-srcset');
            img.removeAttribute('data-sizes');
          
            // ** Add fetchpriority="high" **
            img.setAttribute('fetchpriority', 'high');
        }
    });
});